<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="900px" persistent v-model="dialogForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat>
            <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form @submit.prevent="submit" lazy-validation ref="form" v-model="valid">
            <v-card-text class="pb-0">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" cols="3">
                    <v-text-field
                      :error-messages="errors.data_dia"
                      class="pa-0"
                      dense
                      label="Data"
                      outlined
                      type="date"
                      disabled
                      readonly
                      v-model="formData.data_dia"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="9">
                    <v-autocomplete
                      :error-messages="errors.dia_evento_id"
                      :items="tipos_eventos"
                      clearable
                      dense
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      label="Tipo Evento"
                      outlined
                      placeholder="Selecione o tipo de evento"
                      v-model="formData.dia_evento_id"
                      :loading="loadingEventos"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleForm" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn
                :disabled="!valid"
                :loading="loadingSubmit"
                color="green"
                dark
                depressed
                type="submit"
              >
                <v-icon left small>mdi-send</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage, { toastResponseError } from '@/services/util/alertService';
import diaEventoHttp from '@/services/http/resources/frota/diaEventoHttp';

export default {
  name: 'EventoModalForm',
  data: () => ({
    valid: true,
    tipos_eventos: [],
    formData: {
      id: '',
      data_dia: '',
      competencia_id: '',
      dia_evento_id: '',
    },
    formDataDefault: {
      id: '',
      data_dia: '',
      competencia_id: '',
      dia_evento_id: '',
    },
    errors: {
      dia_evento_id: [],
    },
    loadingSubmit: false,
    loadingEventos: false,
  }),
  computed: {
    ...mapState('dia', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return 'Editar Evento';
    },
  },
  methods: {
    ...mapActions('competencia', ['find']),
    ...mapActions('dia', ['toggleForm', 'update', 'setDataIndex', 'clearData']),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loadingSubmit = true;
        this.formData.data = this.formData.data_dia;
        this.update(this.formData)
          .then(() => {
            toastMessage.successSave('Evento salvo com sucesso');
            this.$refs.form.reset();
            this.find({ id: this.$route.params.id });
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave();
            }
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    openDialog() {
      this.resetValidation();
      this.loadTiposEvento().then(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.data[key];
        });
      });
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    async loadTiposEvento() {
      this.loadingEventos = true;
      await diaEventoHttp
        .list()
        .then(({ data: { data } }) => {
          this.tipos_eventos = data;
        })
        .catch((error) => toastResponseError(error))
        .finally(() => {
          this.loadingEventos = false;
        });
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
    'formData.dia_evento_id': function () {
      this.errors.dia_evento_id = [];
    },
  },
};
</script>
